import type { RealtimeChannel } from "ably";
import { useChannel as useAblyReactChannel } from "ably/react";
import { getRuntimeConfig } from "../core";

export function useChannel<T = RealtimeChannel>(channelName: string, onMessage?: (message: unknown) => void) {
	const logger = getRuntimeConfig().logger;

	const { channel } = useAblyReactChannel(
		{
			channelName,
			onConnectionError: (error) => {
				logger.warning("INFO", "Ably channel connection error", {
					channelName,
					error: error?.message,
					code: error?.code,
				});
			},
		},
		onMessage,
	);

	return { channel: channel as unknown as T | null };
}
